import { render, staticRenderFns } from "./RelatorioExcel.vue?vue&type=template&id=082ea3d8"
import script from "./RelatorioExcel.vue?vue&type=script&lang=js"
export * from "./RelatorioExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports